import { getPaymentMethods } from "@/services/paymentMethodService";
import { useQuery } from "react-query";

export const usePaymentMethods = () => {
  return useQuery({
    queryKey: ["payment-methods"],
    queryFn: getPaymentMethods,
  });
};
